export enum TaskType{
    kanban = "Kanban Task",
    atlas = "Atlas Phase"
}